import { colorBaseGreyWarm50, ProductHeading, Spacing } from '@issuu/silkscreen';
import React from 'react';
import styled from 'styled-components';
import { StoryContent } from '../Story';
import Publication from './Publication';
const PublicationInfoBlock = styled.div `
    background-color: ${colorBaseGreyWarm50};
`;
const PublicationWrapper = styled.div `
    max-width: ${props => (props.isDesktop ? '450px' : '300px')};
`;
const Content = styled(StoryContent) `
    width: 100%;
    padding-top: 1em;
    padding-bottom: 1em;
`;
const PublicationInfo = ({ publisherDisplayName, publicationTitle, publicationUrl, publisherUrl, publicationCoverUrl, pageRange, publicationPublishDate, onPublicationClicked, onPublisherClicked, isDesktop, }) => (React.createElement(PublicationInfoBlock, null,
    React.createElement(Content, null,
        React.createElement(Spacing, { ...(isDesktop ? { bottom: 4, top: 3 } : { bottom: 1 }) },
            React.createElement(ProductHeading, { level: 3, step: isDesktop ? 'negative-1' : 'negative-2' }, "This story is from:")),
        React.createElement(PublicationWrapper, { isDesktop: isDesktop },
            React.createElement(Spacing, { bottom: isDesktop ? 5 : 0 },
                React.createElement(Publication, { coverUrl: publicationCoverUrl, onPublicationClicked: onPublicationClicked, onPublisherClicked: onPublisherClicked, pageRange: pageRange, publishDate: publicationPublishDate, publisherDisplayName: publisherDisplayName, publisherProfileUrl: publisherUrl, readUrl: publicationUrl, title: publicationTitle }))))));
export default PublicationInfo;
//# sourceMappingURL=PublicationInfo.js.map